import { createBrowserHistory } from 'history'
import * as React from 'react'
import { Route, Router, Switch } from 'react-router-dom'

import { withAuthorization, withCondition } from 'components/Session'

import AddChild from 'pages/AddChild'
import AddPatient from 'pages/AddPatient'
import CreatePassword from 'pages/CreatePassword'
import EditPatient from 'pages/EditPatient'
import { EmailHandler } from 'pages/EmailHandler'
import EvaluationGames from 'pages/EvaluationGames'
import Login from 'pages/Login'
import ParentProfile from 'pages/ParentProfile'
import SignUp from 'pages/SignUp'
import ChildrenList from '../pages/ChildrenList'
import Confirmation from '../pages/Confirmation'
import EvaluationQuestionnaires from '../pages/EvaluationQuestionnaires'
import ForgotPassword from '../pages/ForgotPassword'
import Instructions from '../pages/Instructions'
// import Landing from '../pages/Landing'
import PatientDetails from '../pages/PatientDetails'
import Payment from '../pages/Payment'
import Questionnaires from '../pages/Questionnaires'
// import Payment from '../pages/PaymentUnuse'
import WelcomeScreen from '../pages/WelcomeScreen'

import {
  logged,
  loggedAndParent,
  // loggedAndPlusUser,
  notLogged,
  notPlusUserAndLogged,
  plusUser
} from './controllers'

import { withChildListener } from 'components/ChildListener/withChildListener'
import CongratulationsPayment from 'pages/CongratulationsPayment'
import { _route } from './config'

const history = createBrowserHistory()
if (process.env.REACT_APP_IS_PROD !== 'true') {
  history.listen(location => {
    console.log('tracking page view: ' + location.pathname)
  })
}

const landingUrl = process.env.REACT_APP_LANDING_URL
export default class RoutesContainer extends React.PureComponent {
  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route
            exact={true}
            path={_route.login}
            component={withAuthorization(notLogged, _route.child.list)(Login)}
          />
          <Route
            exact={true}
            path={_route.password.create}
            component={CreatePassword}
          />
          <Route
            exact={true}
            path="/signup/:userRole"
            component={withAuthorization(notLogged, _route.child.list)(SignUp)}
          />
          <Route
            exact={true}
            path={_route.password.forgot}
            component={withAuthorization(
              notLogged,
              _route.child.list
            )(ForgotPassword)}
          />
          <Route
            exact={true}
            path={_route.payment}
            component={withCondition((props, prevProps) => {
              // withAuthorization(notPlusUserAndLogged, '/')
              const { plus_user } = props

              // checked if plus_user changed
              if (
                prevProps &&
                plus_user?.isPlusUser &&
                !prevProps.plus_user?.isPlusUser
              ) {
                // console.log('update on payment page')
                return _route.confirmation
              }

              if (plusUser(props)) {
                return _route.child.list
              } else if (notLogged(props) && landingUrl) {
                window.location.href = landingUrl
              }

              return undefined
            })(Payment)}
          />
          <Route
            exact={true}
            path={_route.welcome}
            component={withAuthorization(
              logged,
              _route.child.list
            )(WelcomeScreen)}
          />
          <Route
            exact={true}
            path="/confirmation/:email"
            component={withAuthorization(
              plusUser,
              _route.payment
            )(Confirmation)}
          />

          <Route
            exact={true}
            path="/questionnaires"
            component={withAuthorization(
              logged,
              _route.child.list
            )(withChildListener(Questionnaires))}
          />
          <Route
            exact={true}
            path={_route.patient.edit()}
            component={withAuthorization(
              logged,
              _route.child.list
            )(EditPatient)}
          />
          <Route
            exact={true}
            path={_route.patient.add}
            component={withAuthorization(logged, _route.child.list)(AddPatient)}
          />
          <Route
            exact={true}
            path={_route.patient.unit()}
            component={withAuthorization(
              logged,
              _route.child.list
            )(PatientDetails)}
          />
          <Route
            exact={true}
            path={_route.child.add}
            component={withAuthorization(logged, _route.child.list)(AddChild)}
          />
          <Route
            exact={true}
            path={_route.abilities()}
            component={withAuthorization(
              logged,
              _route.child.list
            )(withChildListener(PatientDetails))}
          />
          <Route
            exact={true}
            path={_route.games()}
            component={withAuthorization(
              loggedAndParent,
              _route.child.list
            )(withChildListener(EvaluationGames))}
          />
          <Route
            exact={true}
            path={_route.questionnaires()}
            component={withAuthorization(
              loggedAndParent,
              _route.child.list
            )(withChildListener(EvaluationQuestionnaires))}
          />
          <Route
            exact={true}
            path={_route.profile}
            component={withAuthorization(
              logged,
              _route.child.list
            )(ParentProfile)}
          />
          <Route
            exact={true}
            path={_route.instructions}
            component={withAuthorization(
              logged,
              _route.child.list
            )(Instructions)}
          />
          <Route
            exact={true}
            path={_route.child.list}
            component={withAuthorization(logged, _route.login)(ChildrenList)}
          />
          <Route
            exact={true}
            path={_route.emailHandler}
            component={EmailHandler}
          />
          <Route
            exact={true}
            path={_route.confirmation}
            component={withAuthorization(
              plusUser,
              _route.payment
            )(CongratulationsPayment)}
          />

          <Route
            exact={true}
            path="/"
            component={withCondition((props, prevProps) => {
              if (logged(props)) {
                return _route.child.list
              } else if (notPlusUserAndLogged(props)) {
                return _route.payment
              }

              return '/signup/parent'
            })()}
          />
          <Route
            exact={true}
            path="*"
            component={withCondition((props, prevProps) => {
              if (logged(props)) {
                return _route.child.list
              } else if (notPlusUserAndLogged(props)) {
                return _route.payment
              }

              return undefined
            })(props => {
              if (landingUrl && !props.altRoute) {
                window.location.href = landingUrl
              }
              return null
            })}
          />
        </Switch>
      </Router>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/index.tsx